import React from 'react';
import { motion } from 'framer-motion';

const ElevatorIntro = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-12 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5"
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-6 flex items-center">
              <span className="w-8 h-px bg-[#91756A] mr-4"></span> Introduction
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] leading-[1.1] mb-12 italic tracking-tighter">
              Essential Mobility <br />
              <span className="text-[#91756A]">Engineered</span> for Excellence.
            </h3>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-7 space-y-8 text-slate-500 text-lg leading-relaxed pt-12 lg:pt-24"
          >
            <p>
              Efficient vertical mobility is essential for the functionality and performance of modern buildings. VASTECH 
              provides comprehensive elevator solutions designed to deliver smooth movement, operational reliability, 
              and advanced safety standards.
            </p>
            <div className="p-8 border-l-4 border-[#91756A] bg-slate-50 italic">
              <p className="text-xl text-slate-600 leading-relaxed">
                Our engineering team develops customized elevator systems that match the architectural design, traffic 
                requirements, and operational needs of each project.
              </p>
            </div>
            <p>
              From residential towers to commercial developments, we deliver vertical transportation systems that combine 
              innovation with long-term durability, ensuring every floor is within easy reach.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ElevatorIntro;